import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface CarouselNavigationProps {
  direction: 'previous' | 'next';
  onClick: (e: React.MouseEvent | React.TouchEvent) => void;
  disabled?: boolean;
  isMobile?: boolean;
}

const CarouselNavigation: React.FC<CarouselNavigationProps> = ({
  direction,
  onClick,
  disabled = false,
  isMobile = false,
}) => {
  const isPrevious = direction === 'previous';
  const Icon = isPrevious ? ChevronLeft : ChevronRight;
  const lastClickTime = useRef(0);
  const CLICK_DEBOUNCE_MS = 300;

  const handleClick = (e: React.MouseEvent) => {
    if (!disabled) {
      const now = Date.now();
      if (now - lastClickTime.current >= CLICK_DEBOUNCE_MS) {
        lastClickTime.current = now;
        e.stopPropagation();
        onClick(e);
      }
    }
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (!disabled) {
      const now = Date.now();
      if (now - lastClickTime.current >= CLICK_DEBOUNCE_MS) {
        lastClickTime.current = now;
        e.stopPropagation();
        onClick(e);
      }
    }
  };

  const buttonSize = isMobile ? '26px' : '34px';

  return (
    <button
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      disabled={disabled}
      className="ceen-glass"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: buttonSize,
        height: buttonSize,
        minWidth: buttonSize,
        minHeight: buttonSize,
        borderRadius: '50%',
        border: 'none',
        // backgroundColor: disabled ? '#F3F4F6' : 'rgba(230, 0, 126, 1)',
        boxShadow: disabled ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.3)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        flexShrink: 0,
        zIndex: 10,
        padding: isMobile ? '8px' : '4px',
        userSelect: 'none',
        touchAction: 'manipulation',
      }}
      onMouseEnter={e => {
        if (!disabled && !isMobile) {
          const target = e.target as HTMLElement;
          target.style.transform = 'scale(1.05)';
        }
      }}
      onMouseLeave={e => {
        if (!disabled && !isMobile) {
          const target = e.target as HTMLElement;
          target.style.transform = 'scale(1)';
        }
      }}
      onMouseDown={e => {
        if (!disabled && !isMobile) {
          const target = e.target as HTMLElement;
          target.style.transform = 'scale(0.95)';
        }
      }}
      onMouseUp={e => {
        if (!disabled && !isMobile) {
          const target = e.target as HTMLElement;
          target.style.transform = 'scale(1.05)';
        }
      }}
      onFocus={e => {
        e.target.style.outline = 'none';
      }}
    >
      <Icon
        size={14}
        color={disabled ? 'var(--color-content-muted)' : 'var(--color-accent)'}
        style={{
          strokeWidth: 2,
        }}
      />
    </button>
  );
};

export default CarouselNavigation;
